import { DeviceRoles } from '@vi-iot/client';
import { RemoteDeviceType } from '../commissioning/commissioning.model';

export function isRemoteDeviceOfType(roles: string[], type: RemoteDeviceType): boolean {
  if (!roles?.length) {
    return;
  }

  return type === getTypeOfRemoteDevice(roles);
}

export function getFhtMainFromChannel(deviceId: string): string {
  const splitedId = deviceId.split('-');

  return splitedId.length === 3 ? splitedId.slice(0, -1).join('-') : deviceId;
}

export function getTypeOfRemoteDevice(roles: string[]): RemoteDeviceType {
  if (
    roles.includes(DeviceRoles.ClimateSensor) &&
    roles.includes(DeviceRoles.Sensor) &&
    roles.includes(DeviceRoles.SmartRoomDevice)
  ) {
    return RemoteDeviceType.CS;
  } else if (
    roles.includes(DeviceRoles.Actuator) &&
    roles.includes(DeviceRoles.Radiator) &&
    roles.includes(DeviceRoles.SmartRoomDevice)
  ) {
    return RemoteDeviceType.TRV;
  } else if (roles.includes(DeviceRoles.Repeater) && roles.includes(DeviceRoles.SmartRoomDevice)) {
    return RemoteDeviceType.REPEATER;
  } else if (roles.includes(DeviceRoles.FhtMain) && roles.includes(DeviceRoles.SmartRoomDevice)) {
    return RemoteDeviceType.FHT;
  } else if (
    roles.includes(DeviceRoles.FhtChannel) &&
    roles.includes(DeviceRoles.SmartRoomDevice)
  ) {
    return RemoteDeviceType.FHT_CHANNEL;
  } else if (
    roles.includes(DeviceRoles.Co2Sensor) &&
    roles.includes(DeviceRoles.Sensor) &&
    roles.includes(DeviceRoles.SmartRoomDevice)
  ) {
    return RemoteDeviceType.AIR_QUALITY_SENSOR;
  } else if (
    roles.includes(DeviceRoles.RemoteControllerVitotrol100E) &&
    roles.includes(DeviceRoles.SmartRoomDevice)
  ) {
    return RemoteDeviceType.VITOTROL_100E;
  } else if (
    roles.includes(DeviceRoles.RemoteControllerVitotrol300E) &&
    roles.includes(DeviceRoles.SmartRoomDevice)
  ) {
    return RemoteDeviceType.VITOTROL_300E;
  }
}
